import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { colors } from "../config/colors";
import { Button, Spinner } from "react-bootstrap";
import { DISPLAY_FLEX, FLEX_JUSTIFY_CENTER } from "../config/styles";

const SecondaryButtonStyled = styled(Button)(({ theme }) => ({
  ...theme.typography.body1,
  display: DISPLAY_FLEX,
  flex: 1,
  height: "40px",
  justifyContent: FLEX_JUSTIFY_CENTER,
  backgroundColor: "transparent",
  color: colors.custom,
  border: `1px solid ${colors.grayBackground}`,
  borderRadius: "4px",
  padding: "8px 16px",
  "&:disabled": {
    backgroundColor: colors.grayBackground,
    borderColor: "none",
    color: colors.nonActive,
    cursor: "not-allowed",
  },
}));

export const SecondaryButton = ({
  label = "",
  disabled = false,
  isLoading = false,
  onClick = null,
  spinnerColor = "secondary",
}) => {
  const btnChild = isLoading ? (
    <div style={{ marginTop: -30 }}>
      <Spinner animation="border" variant={spinnerColor} size="sm" />
    </div>
  ) : (
    label
  );
  return (
    <SecondaryButtonStyled
      bsPrefix="button-secondary"
      onClick={onClick}
      disabled={isLoading || disabled}
    >
      {btnChild}
    </SecondaryButtonStyled>
  );
};

SecondaryButton.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  spinnerColor: PropTypes.string,
};
